import React, { Component } from 'react';
import styled from 'styled-components';

import heroLogo from "../../images/icons/heroLogoWhite.png";
import { WhiteFooterButtonTitle } from "../Fonts";
import { Button } from "../button/ActionButton";
import { Link } from 'react-router-dom';

import Twitter from "./twitterWhite.png";
import Instagram from "./instagramWhite.png";
import Mail from "./mailWhite.png";

const Icon = styled.div<{ icon: string }>`
  width: 28px;
  height: 28px;
  background: url(${props => props.icon}) no-repeat center;
  background-size: 28px;
  margin-top: 0;
  margin-bottom: 24px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 80px 40px 40px;
  background-color: transparent;

  @media only screen and (max-width: 896px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const FooterButton = styled(Button)`
  margin-bottom: 8px;
  background-color: rgba(250, 248, 247, 0.24);

  &:hover {
    background-color: rgba(250, 248, 247, 0.16);
  }
`;

const FooterSubtitle = styled.span`
  font: 12px "Euclid Circular A", sans-serif;
  font-weight: 400;
  line-height: 16px;
  color: rgba(250, 248, 247, 0.4);
  margin-top: 24px;
`;

const SocialWrapper = styled.div`
`;

const SocialMediaButton = styled.button<{image: string}>`
  background:  url(${props => props.image}) no-repeat center;
  background-size: 24px;
  width: 24px;
  height: 24px;
  border: none;
  cursor:pointer;
  margin-right: 8px;
  margin-left: 8px;
  
  &:hover {
    opacity: .5;
  }
  &:focus {
    outline:0;
  }
`;



class TransparentFooter extends Component {
  //  As the landing pages is static, there is no need to re-render.
  shouldComponentUpdate() {
    return false;
  }

  onClickInstagram() {
    window.open("https://www.instagram.com/joinzebra/",'_blank');
  }

  onClickTwitter() {
    window.open("https://twitter.com/joinzebra",'_blank');
  }

  onClickMail() {
    window.open('mailto:hello@zebra.chat', '_blank');
  }

  render() {
    return (
      <Container>
        <div style={{display: "flex"}}>
          <Icon icon={heroLogo}/>
          <div style={{flex: 1}}></div>
          <SocialWrapper>
            <SocialMediaButton image={Instagram} onClick={this.onClickInstagram}/>
            <SocialMediaButton image={Twitter} onClick={this.onClickTwitter}/>
            <SocialMediaButton image={Mail} onClick={this.onClickMail}/>
          </SocialWrapper>
        </div>
        <div>
          <FooterButton height={32}>
            <Link to="/tos" style={{ textDecoration: 'none' }}>
              <WhiteFooterButtonTitle>Terms of Service</WhiteFooterButtonTitle>
            </Link>
          </FooterButton>
          <FooterButton height={32}>
            <Link to="/privacy" style={{ textDecoration: 'none' }}>
              <WhiteFooterButtonTitle>Privacy Policy</WhiteFooterButtonTitle>
            </Link>
          </FooterButton>
          <FooterButton height={32}>
            <a href="./PressKit.zip" style={{ textDecoration: 'none' }} download>
              <WhiteFooterButtonTitle>Press Kit</WhiteFooterButtonTitle>
            </a>
          </FooterButton>
        </div>
        <FooterSubtitle>
          © Zebra Labs Inc.
        </FooterSubtitle>
      </Container>
    );
  }
}

export default TransparentFooter;